export const style = {
    minWidth: '200px',
    minHeight: '55px',
    border: '1px solid #B2F142',
    padding: '10px',
    color: '#B2F142',
    background: '#000',


}

export const iconTheme = {
    primary: '#B2F142',
    secondary: '#000',
}

export const position = {
    position: "bottom-right"
}